import { z } from 'zod';
import {
  TextCollectionField,
  TextCollectionFieldType,
} from '@scale/shared/types/params/textcollection';

export function fieldsToZodSchema(fields: Array<TextCollectionField>) {
  const schemaObject: Record<string, z.ZodTypeAny> = {};

  //   TextCollectionFieldType.TranscriptionText,
  //   TextCollectionFieldType.Datetime,
  //   TextCollectionFieldType.Category,
  //   TextCollectionFieldType.Select,

  fields.forEach(field => {
    let fieldSchema;

    switch (field.type) {
      case TextCollectionFieldType.Text:
        fieldSchema = z.string();
        if (field.required) {
          fieldSchema = fieldSchema.trim().min(1, { message: 'This field cannot be empty' });
        }

        if (field.min_characters) {
          fieldSchema = fieldSchema.min(field.min_characters, {
            message: `This field must be at least ${field.min_characters} characters long`,
          });
        }

        if (field.max_characters) {
          fieldSchema = fieldSchema.max(field.max_characters, {
            message: `This field must be at most ${field.max_characters} characters long`,
          });
        }
        break;
      case TextCollectionFieldType.Boolean:
        fieldSchema = z.boolean();
        break;
      case TextCollectionFieldType.Number:
        fieldSchema = z.coerce.number();

        if (field.min) {
          fieldSchema = fieldSchema.min(field.min, {
            message: `This field must be at least ${field.min}`,
          });
        }
        if (field.max) {
          fieldSchema = fieldSchema.max(field.max, {
            message: `This field must be at most ${field.max}`,
          });
        }

        if (field.required) {
          const numberSchema = fieldSchema;

          fieldSchema = z
            .string()
            .trim()
            .min(0, { message: 'This field cannot be empty' })
            .pipe(numberSchema);
        }

        break;
      case TextCollectionFieldType.Category:
        fieldSchema = z.union([z.string(), z.array(z.string())]);
        if (field.required) {
          fieldSchema = fieldSchema.refine(
            value => {
              if (Array.isArray(value)) {
                return value.length > 0;
              }
              return value.length > 0;
            },
            {
              message: 'This field cannot be empty',
            },
          );
        }
        if (typeof field.max_choices === 'number') {
          fieldSchema = fieldSchema.refine(
            value => {
              if (Array.isArray(value)) {
                return value.length <= field.max_choices!;
              }
              return value.length <= field.max_choices!;
            },
            {
              message: `This field must have at most ${field.max_choices} choices`,
            },
          );
        }
        if (typeof field.min_choices === 'number') {
          fieldSchema = fieldSchema.refine(
            value => {
              if (Array.isArray(value)) {
                return value.length >= field.min_choices!;
              }
              return value.length >= field.min_choices!;
            },
            {
              message: `This field must have at least ${field.min_choices} choices`,
            },
          );
        }
        break;
      case TextCollectionFieldType.Select:
        fieldSchema = z.union([z.string(), z.array(z.string())]);
        break;
      default:
        throw new Error(`Unsupported field type: ${field.type}`);
    }

    schemaObject[field.field_id] = fieldSchema;
  });

  return z.object(schemaObject);
}
